import {http, param} from '../../utils/http'
import conf from '../../config'

export const API_ROOT = `${conf.API_URL}`

// Service for Recalls Review API integration
const recallReviewServices = {
    getRecallReviews(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/recallreviews${param(arr)}`).then(resp => {
            return resp
        })
    },

    getRecallReviewById(id, source) {
        const url = source
            ? `${API_ROOT}/notisphere/recallreviews/${id}?source=${source}`
            : `${API_ROOT}/notisphere/recallreviews/${id}`
        return http.get(url).then(resp => {
            return resp
        })
    },

    downloadAgGridRecallReviewXLSX(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'email', val: payload.email ? encodeURIComponent(payload.email) : null },
            { query: 'filterModel', val: payload.filterModel ? encodeURIComponent(JSON.stringify(payload.filterModel)) : null }
        ]
        return http.get(`${API_ROOT}/notisphere/recallreviews/downloadAgGridRecallReviewxlsx${param(arr)}`).then(resp => {
            return resp
        })
    },

    downloadChangeLogReport(payload) {
        var arr = [
            { query: 'email', val: payload ? encodeURIComponent(payload) : null }
        ]
        return http.get(`${API_ROOT}/notisphere/recallreviews/downloadChangeLog${param(arr)}`).then(resp => {
            return resp
        })
    },

    updateRecallReview(id, payload) {
        return http.put(`${API_ROOT}/notisphere/recallreviews/${id}`, payload).then(resp => {
            return resp
        })
    },

    recallReviewOriginalityStats(recallId, originality, payload) {
        return http.put(`${API_ROOT}/notisphere/recallreviews/originality/${recallId}/${originality}`, payload).then(resp => {
            return resp
        })
    },
    getRecallMetaData () {
        return http.get(`${API_ROOT}/notisphere/communications/meta`).then(resp => {
            return resp
        })
    },

    publishRecall(id, payload) {
        return http.post(`${API_ROOT}/notisphere/recallreviews/publishRecall/${id}`, payload).then(resp => {
            return resp
        })
    },

    uploadRecallDocuments(id, files) {
        const formData = new FormData()
        for (const f of files) {
            formData.append('files', f)
        }
        return http.post(`${API_ROOT}/notisphere/recallreviews/${id}/documents`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(resp => resp)
    },

    deleteRecallDocument(id, inputFile) {
        const arr = [
            { query: 'inputFile', val: inputFile ? encodeURIComponent(inputFile) : null }
        ]
        return http.delete(`${API_ROOT}/notisphere/recallreviews/${id}/documents${param(arr)}`).then(resp => resp)
    },

    // Search recall reviews (e.g. for "Find Original") - only Originals, search on recall_name and recalling_firm
    searchOriginalsForLink(searchText) {
        const arr = [
            { query: 'pageNumber', val: 1 },
            { query: 'pageSize', val: 100 },
            { query: 'search', val: searchText ? searchText.trim() : '' }
        ]
        return http.get(`${API_ROOT}/notisphere/recallreviews/searchOriginals${param(arr)}`).then(resp => resp)
    },

    // Link current recall to a chosen original (mark as duplicate under that original)
    linkRecallToOriginal(recallId, payload) {
        return http.put(`${API_ROOT}/notisphere/recallreviews/${recallId}/linkToOriginal`, payload).then(resp => resp)
    },

    // Revert a Duplicate recall back to Possible Duplicate (status PENDING)
    revertDuplicateToPossibleDuplicate(recallId, payload = null) {
        return http.put(`${API_ROOT}/notisphere/recallreviews/${recallId}/revertDuplicate`, payload || {}).then(resp => resp)
    },
}

export default recallReviewServices
